import { GetScheduledPrefilledDateTime, IsStartDateInPast } from '../Models'
import { convertUTCToLocal, setDefaultTimeIfEmpty } from './DataCategoryUtils'
import { getCurrentAndPrevTime } from './Util'

export const getInitialDateTime = (offsetMinutes?: number) => {
  const offsetMinutesValue = !offsetMinutes || offsetMinutes < 0 ? 0 : offsetMinutes
  const initialDate = new Date()
  initialDate.setMinutes(initialDate.getMinutes() + offsetMinutesValue)
  initialDate.setSeconds(0)
  initialDate.setMilliseconds(0)
  return initialDate
}
export const isStartDateInPast = ({ startFieldKey, selectedAsset }: IsStartDateInPast) => {
  const startTimeFieldValue = selectedAsset?.[startFieldKey]
  if (!startTimeFieldValue) return false
  const startDate = convertUTCToLocal(startTimeFieldValue)
  if (!startDate) return false
  const { nowAtMinute, valueAtMinute } = getCurrentAndPrevTime(startDate)
  return valueAtMinute <= nowAtMinute
}
export const getScheduledPrefilledDateTime = ({
  clearErrors,
  endFieldKey,
  endFieldSetter,
  reset,
  startFieldKey,
  startFieldSetter,
  selectedAsset,
  isPinnedImmediately,
}: GetScheduledPrefilledDateTime) => {
  let startDate: Date | null = null
  let endDate: Date | null = null

  const startTimeValue = selectedAsset?.[startFieldKey]
  const endTimeValue = selectedAsset?.[endFieldKey]
  if (startTimeValue) startDate = convertUTCToLocal(startTimeValue)
  if (endTimeValue) endDate = convertUTCToLocal(endTimeValue)

  if (isPinnedImmediately) {
    startFieldSetter(null)
  }
  const updatedStartDateTime = isPinnedImmediately
    ? null
    : setDefaultTimeIfEmpty({
        offsetMinutes: 1,
        value: startDate,
        setter: startFieldSetter,
      })
  reset({
    [startFieldKey]: updatedStartDateTime,
    [endFieldKey]: endDate,
  })
  endFieldSetter(endDate)
  clearErrors()
}
export const validateStartDateTimeValue = (value: Date | null, isStartTimeDisabled: boolean) => {
  if (!value || isStartTimeDisabled) return true

  const { nowAtMinute, valueAtMinute } = getCurrentAndPrevTime(value)

  if (valueAtMinute <= nowAtMinute) {
    return 'Start date & time must be later than the current date & time.'
  }

  return true
}
export const validateEndDateTimeValue = (value: Date | null, startTimeValue: Date | null) => {
  if (!value) return true

  const { nowAtMinute, valueAtMinute } = getCurrentAndPrevTime(value)

  if (valueAtMinute <= nowAtMinute) {
    return 'End time cannot be in the past'
  }

  if (startTimeValue) {
    const startAtMinute = new Date(startTimeValue)
    startAtMinute.setSeconds(0)
    startAtMinute.setMilliseconds(0)

    if (valueAtMinute <= startAtMinute) {
      return 'End time must be after start time'
    }
  }

  return true
}
